<template>
    <van-row class="room_flow">
      <van-col span="22" offset="1" class="room_flow_top">
        <van-col span="6">
          <van-image
            round
            width="3.5rem"
            height="3.5rem"
            :src="voice.room_img"
          />
        </van-col>
        <van-col span="18">
          <van-col span="24" class="room_flow_room_name"> {{ voice.room_title }} </van-col>
          <van-col span="24" class="room_flow_id">ID: {{ voice.room_id }} </van-col>
        </van-col>
      </van-col>
      <van-col span="10" :offset="1" class="room_flow_room_div">
        <van-col span="24" class="room_flow_room_div_number">
          {{ voice.today }}
        </van-col>
        <van-col span="24" class="room_flow_room_div_name">
          {{ $t('column.Total_room_today') }}
        </van-col>
      </van-col>
      <van-col span="10" :offset="2" class="room_flow_room_div">
        <van-col span="24" class="room_flow_room_div_number">
          {{ voice.yesterday }}
        </van-col>
        <van-col span="24" class="room_flow_room_div_name">
          {{ $t('column.Total_room_yesterday') }}
        </van-col>
      </van-col>

      <van-col span="10" :offset="1" class="room_flow_room_div">
        <van-col span="24" class="room_flow_room_div_number">
          {{ voice.month }}
        </van-col>
        <van-col span="24" class="room_flow_room_div_name">
          {{ $t('column.Total_room_month') }}
        </van-col>
      </van-col>
      <van-col span="10" :offset="2" class="room_flow_room_div">
        <van-col span="24" class="room_flow_room_div_number">
          {{ voice.last_month }}
        </van-col>
        <van-col span="24" class="room_flow_room_div_name">
          {{ $t('column.Total_room_last_month') }}
        </van-col>
      </van-col>
    </van-row>
</template>
<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
export default {
  data() {
    return {
      voice:{},
    }
  },
  created: function() {
    this.convert();
    document.title = this.$t('title.room_flow')
  },
  methods: {
    convert: function() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const room_id = this.$route.query.room_id
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=voice&act=get_room_flow", {
        params : {
          uid: uid,
          token: token,
          room_id: room_id
        }
      }).then(res =>{
        console.log(res.data)
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }else{
          this.voice = res.data.data
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/room_flow.vue